<template>
  <div class="axt-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <div class="iframe-box">
      <iframe src="https://www.aixuetang.com/" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index'


export default {


  data() {
    return {

    }
  },


  methods: {
    isMobile
  },

  created() {

  }
}
</script>

<style lang="scss">
.axt-container {
  height: calc(100vh - 72px);
}

.iframe-box {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
